import stylesGlobal from '../../style';

const styles = {
  dataContainer: {
    height: 295,
    backgroundColor: stylesGlobal.neutral0,
  },
  buttonHoverSelengkapnya: {
    background: 'none',
  },
  buttonFilter: {
    marginRight: 8,
    backgroundColor: stylesGlobal.neutral0,
  },
  buttonFilterActive: {
    backgroundColor: stylesGlobal.primaryBackground,
    borderColor: stylesGlobal.primary,
    color: stylesGlobal.primary,
  },
  buttonFilterHover: {
    marginRight: 8,
    backgroundColor: stylesGlobal.primaryBackground,
    borderColor: stylesGlobal.primary,
    color: stylesGlobal.primary,
  },
  dataRow: {
    cursor: 'pointer',
    paddingLeft: 16,
    paddingRight: 16,
  },
};

export default styles;
